import React, { useEffect, useState } from "react";
import s from "./GamesModal.module.css";

//assets
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

//materialUi
import {
  CircularProgress,
  Grid,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Pagination,
  TextField,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getGameOffers } from "../../../api/games/GamesService";
import raffleService from "../../../api/raffles/RafflesService";
const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "14px",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

const disabled = {
  backgroundColor: "rgba(193,193,193,0.56)",
  color: "#7C7C7C",
  cursor: "not-allowed",
  "&hover": { backgroundColor: "rgba(193,193,193,0.56)" },
};

const GamesModal = ({ open, setOpen, selectGame, type, gameId, modeId }) => {
  const { t } = useTranslation();
  const { textColor } = useSelector((state) => state.local);
  const { activeOrganization } = useSelector((state) => state.gamma);

  const [items, setItems] = useState([]);
  const dispatch = useDispatch();

  //paginado
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(0);
  const [query, setQuery] = useState({ query: "" });
  const [sort, setSort] = useState({
    criteria: "ASC",
    field: "",
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handlePaginate = (e, v) => {
    setPage(v);
  };

  useEffect(() => {
    setLoading(true);
    raffleService
      .getAllRafflesFiltered(
        page,
        20,
        gameId,
        modeId,
        query,
        dispatch,
        sort,
      )
      //getAllRaffles(activeOrganization?.id,  dispatch, page)
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false));
  }, [page, searching, sort]);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={11} className={s.exit}>
              <div className={s.titleModal}>
                <p>{t("game")}</p>
                <span>{t("select")}</span>
              </div>
              <CloseIcon
                onClick={() => setOpen(false)}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>

            <Grid
              item
              xs={11}
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className={s.search}
            >
              <TextField
                label={t("find")}
                value={query.query}
                onChange={(e) => setQuery({ ...query, query: e.target.value })}
                sx={{ width: "60%" }}
              />
              <Button
                variant="contained"
                disabled={query === ""}
                onClick={() => {
                  setPage(1);
                  setSearching((prev) => prev + 1);
                }}
              >
                {t("find")}
              </Button>
              <Button
                variant="contained"
                disabled={searching === 0}
                onClick={() => {
                  setPage(1);
                  setSearching(0);
                  setQuery({ ...query, query: "" });
                }}
              >
                {t("clear")}
              </Button>
            </Grid>
            {console.log("juegos: ", items)}
            {loading ? (
              <Grid item xs={12} className={s.loader}>
                <CircularProgress />
              </Grid>
            ) : items?.length ? (
              <Grid item container xs={11} className={s.data}>
                <TableContainer className={s.tableContainer}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            "&:hover": { cursor: "pointer" },
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >{`${t("name")}`}</TableCell>
                        <TableCell
                          sx={{
                            "&:hover": { cursor: "pointer" },
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >{`${t("drawNumber")}`}</TableCell>
                        <TableCell
                          sx={{
                            "&:hover": { cursor: "pointer" },
                            backgroundColor: "primary.main",
                            color: textColor,
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >{`${t("serie")}`}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {items.map((item, i) => {
                        return (
                          <React.Fragment key={item.id}>
                            <TableRow
                              sx={
                                item[type]
                                  ? {
                                      "&:hover": {
                                        backgroundColor: "secondary.light",
                                      },
                                    }
                                  : disabled
                              }
                              onClick={() => {
                                if (item[type]) {
                                  selectGame(item);
                                  setOpen(false);
                                }
                              }}
                            >
                              <TableCell
                                sx={
                                  item[type]
                                    ? {
                                        ...cellStyles,
                                        backgroundColor:
                                          i % 2 === 0
                                            ? "#dbdbdb76"
                                            : "#dbdbdd12",
                                      }
                                    : disabled
                                }
                              >
                                {item.game.name}
                              </TableCell>
                              <TableCell
                                sx={
                                  item[type]
                                    ? {
                                        ...cellStyles,
                                        backgroundColor:
                                          i % 2 === 0
                                            ? "#dbdbdb76"
                                            : "#dbdbdd12",
                                      }
                                    : disabled
                                }
                              >
                                {item.number || "-"}
                              </TableCell>
                              <TableCell
                                sx={
                                  item[type]
                                    ? {
                                        ...cellStyles,
                                        backgroundColor:
                                          i % 2 === 0
                                            ? "#dbdbdb76"
                                            : "#dbdbdd12",
                                      }
                                    : disabled
                                }
                              >
                                {item.serie || "-"}
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ) : (
              <Grid item xs={12} className={s.noresult}>
                {t("noResults")}
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center", my: 5 }}
              className={s.pagination}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePaginate}
                color="primary"
                disabled={loading}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default GamesModal;
